import React from 'react';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import styles from './studio-section.module.css';

export default function Web3Section() {
  return (
    <div className={styles.web3SectionRoot} data-cy='web3-section'>
      <h1 className={styles.create3dTitle}>Web3</h1>
      <div className={styles.sectionTopContent}>
        <img
          src={`${WEBSITE_PUBLIC_CDN}/web3-future.jpg`}
          alt='Web3 Section image'
          className={styles.web3SectionImage}
        />
        <div className={styles.web3TextWrapper}>
          <span className={styles.defaultWebText}>
            Empowering the Future with Web3
          </span>
          <div className={styles.parWrapper}>
            <div className={styles.defaultWebText}>
              <span className={styles.grayWebText}>
                Blockchain and Web3 technologies are revolutionizing gaming and
                virtual worlds. OZONE has been investing in Web3 infrastructure
                since 2021, providing:
              </span>
              <ul>
                <li>
                  Seamless integration{' '}
                  <span className={styles.grayWebText}>
                    – easy adoption for developers and users.
                  </span>
                </li>
                <li>
                  Digital ownership{' '}
                  <span className={styles.grayWebText}>
                    – true asset control through blockchain.
                  </span>
                </li>
                <li>
                  Interoperability{' '}
                  <span className={styles.grayWebText}>
                    – cross-platform and cross-world compatibility.
                  </span>
                </li>
                <li>
                  Scalability{' '}
                  <span className={styles.grayWebText}>
                    – robust cloud solutions for high-performance experiences.
                  </span>
                </li>
                <li>
                  Immersive 3D technology{' '}
                  <span className={styles.grayWebText}>
                    – cutting-edge tools for virtual environments.
                  </span>
                </li>
              </ul>
              <span className={styles.grayWebText}>
                As Web3 adoption grows, decentralized worlds will shape the
                future of online communities. OZONE is leading this
                evolution—one block at a time.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
